import { render } from "./TravelConsultation.vue?vue&type=template&id=4901961e&scoped=true"
import script from "./TravelConsultation.vue?vue&type=script&lang=js"
export * from "./TravelConsultation.vue?vue&type=script&lang=js"

import "./TravelConsultation.vue?vue&type=style&index=0&id=4901961e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4901961e"]])

export default __exports__